<div class="app-fieldset-component mat-elevation-z2">
  <span class="legend">{{legend}}</span>
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>

